import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'samplicity-form-section',
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss']
})
export class FormSectionComponent implements OnInit {
  @Input() header: string | object[];
  @Input() headerParameters: object;
  @Input() headerIcon: string;
  @Input() isHeaderDynamic: boolean = false
  @Input() isCard: boolean;
  @Input() expanded = true;
  @Input() height = 'auto';
  @Input() level = 1;
  @Input() isWarning = false;
  @Input() isError = false;
  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
  headerClass: string;

  constructor(private translationService: L10nTranslationService){}
  
  get headerIsDto(): boolean {
    return Array.isArray(this.header) && this.header[0] instanceof Object;
  }

  get lang(): string {
    return this.translationService.getLocale().language;
  }

  ngOnInit(): void {
    if (this.isCard) {
      this.headerClass = 'card-section-header';
    }
  }

  openPanel(): void {
    this.expansionPanel.open();
  }

  closePanel(): void {
    this.expansionPanel.close();
  }
}
